import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Button, Column, Columns, Container } from '@resurs/midas-react'
import { getText } from '../../internal/TextLabels'
import Page from '../../internal/Page'
import { loginWithAuthoritiesAndRole } from '../../store/actions/auth-actions'
import { getUserRoles } from '../../store/actions/users-actions'
import PermissionPicker from '../Users/UI/PermissionPicker'

class ChangeUserView extends Component {
  constructor(props) {
    super(props)
    this.state = {
      role: props.currentUser.role,
      authorities: [...props.currentUser.authorities],
    }
    this.props.getUserRoles()
    this.handleChangePermission = this.handleChangePermission.bind(this)
  }

  handleLogin(e) {
    e.preventDefault()
    this.props.fetchNewToken({
      role: this.state.role,
      authorities: this.state.authorities,
    })
  }

  handleChangePermission({ role, authorities }) {
    this.setState({ role, authorities })
  }

  render() {
    return (
      <Container grid960>
        <Columns>
          <Column col2 colMd2 colSm0 />
          <Column col8 colMd8 colSm12>
            <Container>
              <span>{getText('user.changeUserView')}</span>
            </Container>
          </Column>
        </Columns>
        <Columns>
          <Column col2 colMd2 colSm0 />
          <Column col8 colMd8 colSm12>
            <Page title={getText('user.rolesAndAuthorities')}>
              <Container>
                <PermissionPicker
                  user={{
                    role: { name: this.state.role },
                    authorities: this.state.authorities,
                  }}
                  validRoles={this.props.validRoles}
                  loggedInUser={this.props.currentUser}
                  showHint={false}
                  onChange={this.handleChangePermission}
                />
              </Container>
            </Page>
          </Column>
        </Columns>
        <Columns>
          <Column col2 colMd2 colSm0 />
          <Column col8 colMd8 colSm12>
            <Container>
              <Button
                id="login-button"
                type="primary"
                loading={false}
                fullWidth
                onClick={e => this.handleLogin(e)}
              >
                {getText('login.buttonText')}
              </Button>
            </Container>
          </Column>
        </Columns>
      </Container>
    )
  }
}

ChangeUserView.propTypes = {
  currentUser: PropTypes.object.isRequired,
  fetchNewToken: PropTypes.func.isRequired,
  validRoles: PropTypes.array.isRequired,
  getUserRoles: PropTypes.func.isRequired,
}

const mapStateToProps = state => {
  return {
    currentUser: state.auth,
    validRoles: state.users.validRoles,
    stores: state.storeInfo.stores,
  }
}

const mapDispatchToProps = dispatch => ({
  fetchNewToken: data => {
    dispatch(loginWithAuthoritiesAndRole(data))
  },
  getUserRoles: () => {
    dispatch(getUserRoles())
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(ChangeUserView)
